import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import TextfieldEditDisplay from 'formiojs/components/textfield/editForm/TextField.edit.display';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: TextfieldEditDisplay,
    },
    {
      key: 'data',
      ignore: true,
    },
    {
      key: 'validation',
      ignore: true,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 250,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip: 'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Array Instance Title',
          tooltip: 'Include >index< to refer to array index',
          key: 'arrayTitle',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Array path',
          key: 'arrayPath',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'labels to concatenate in array',
          tooltip: 'Make sure to start and end with \',\'',
          placeholder: 'separated by a \',\'',
          key: 'valAsArray',
          input: true,
        },
        {
          weight: 100,
          type: 'textarea',
          label: 'Review field paths',
          placeholder: 'write paths separeted by a \',\'',
          tooltip: 'Write paths to the fiels you want to have in this review section and in the order you want them to be. No need to include \'.data\' as part of the path when accessing a nested form field.',
          key: 'reviewPaths',
          input: true,
        },
        {
          weight: 100,
          type: 'textarea',
          label: 'Files paths',
          placeholder: 'write paths separeted by a \',\'',
          tooltip: 'Write paths to the file fiels you want to have in this review section and in the order you want them to be. No need to include \'.data\' as part of the path when accessing a nested form field.',
          key: 'filePaths',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Section Edit Button',
          key: 'reviewEdit',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Section Edit page',
          key: 'reviewPage',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
